import PropTypes from "prop-types";
import { useBestInTravel } from "@context/bestInTravel/2025/bestInTravelContext";
import { Arrow } from "@icons/elsewhere";
import { tagular } from "@cohesion/tagular";

export function ContentSubmenu({ destination }) {
  const { setDestinationsMenuOpen, handleShareDrawer } = useBestInTravel();

  return (
    <div className="px-6 pt-6 pb-10 lg:px-12">
      <h4 className="pb-4 text-2xl font-normal font-neue">Keep exploring</h4>
      <ul>
        <li>
          <a
            type="button"
            className="flex items-center justify-between w-full pb-4 font-extrabold border-b border-itinerary-blue-200 font-neue text-blue"
            href={destination.slug}
            onClick={() => {
              tagular("click", {
                actionOutcome: "INTERNALLINK",
                outboundUrl: destination.slug,
                webElement: {
                  location: "BIT_KeepExploring",
                  elementType: "LINK",
                  text: `Learn more about ${destination.name}`,
                  name: `${destination.name}`,
                  position: "0",
                },
              });
            }}
          >
            <h4>Learn more about {destination.name}</h4>
            <Arrow className="inline-block" />
          </a>
        </li>
        <li>
          <button
            type="button"
            className="flex items-center justify-between w-full py-4 font-extrabold border-b border-itinerary-blue-200 font-neue text-blue"
            onClick={() => {
              setDestinationsMenuOpen(true);
              tagular("click", {
                actionOutcome: "OPEN",
                outboundUrl: "null",
                webElement: {
                  location: "BIT_KeepExploring",
                  elementType: "BUTTON",
                  text: "View all destinations",
                  name: `${destination.name}`,
                  position: "0",
                },
              });
            }}
          >
            <h4>View all destinations</h4>
            <Arrow className="inline-block" />
          </button>
        </li>
        <li className="border-b border-itinerary-blue-200">
          <button
            type="button"
            className="flex items-center justify-between w-full py-4 font-extrabold font-neue text-blue"
            onClick={() => {
              handleShareDrawer(destination);
              tagular("click", {
                actionOutcome: "OPEN",
                outboundUrl: "null",
                webElement: {
                  location: "BIT_KeepExploring",
                  elementType: "BUTTON",
                  text: "Share the destination",
                  name: `${destination.name}`,
                  position: "0",
                },
              });
            }}
          >
            <h4>Share the destination</h4>
            <Arrow className="inline-block" />
          </button>
        </li>
      </ul>
    </div>
  );
}

ContentSubmenu.propTypes = {
  destination: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
};
